import { withStyles } from '@material-ui/styles';
import locationHistoryStyles from './location-history.style';
import StaffLocationHistoryTab from './staff-location-history-tab';

export default withStyles(locationHistoryStyles)(StaffLocationHistoryTab);
